import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../../service/wp-blogs-store'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-02-01'

export async function getStaticProps() {
    
    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;

  return (
    <>
      <Head>
        <title>{`Best Personal Trainer Certifications for Singapore [${year}]`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Personal training certifications are important to be a successful trainer. Here is a list of personal trainer courses that are recognized in Singapore."/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Best Personal Trainer Certifications for Singapore [${year}]`}/>
        <meta property="og:description" content="Personal training certifications are important to be a successful trainer. Here is a list of personal trainer courses that are recognized in Singapore." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-06T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package6.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary"/>
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package6.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification"/>
        <meta name="twitter:title" content={`Best Personal Trainer Certifications for Singapore [${year}]`}/> 
        <meta name="twitter:description" content="Personal training certifications are important to be a successful trainer. Here is a list of personal trainer courses that are recognized in Singapore."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/#breadcrumblist","itemListElement":[{"@type":"ListItem","@id":"https://www.stringssg.com/#listItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"},"nextItem":"https://www.stringssg.com/sg/personal-trainer/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/sg/personal-trainer/#listItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/","name":"personal-trainer","url":"https://www.stringssg.com/sg/personal-trainer/"},"previousItem":"https://www.stringssg.com/#listItem","nextItem":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/#listItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/","name":"certification","description":"Personal training certifications are important to be a successful trainer. Here is a list of personal trainer courses that are recognized in Singapore.","url":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/"},"previousItem":"https://www.stringssg.com/sg/personal-trainer/#listItem"}]},{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG Singapore","url":"https://www.stringssg.com/"},{"@type":"WebSite","@id":"https://www.stringssg.com/#website","url":"https://www.stringssg.com/","name":"StringsSG Singapore","inLanguage":"en-US","publisher":{"@id":"https://www.stringssg.com/#organization"}},{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/#webpage","url":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/","name":"Best Personal Trainer Certifications for Singapore [${year}]","description":"Personal training certifications are important to be a successful personal trainer. Here is a list of common certifications that are recognized in Singapore.","inLanguage":"en-US","isPartOf":{"@id":"https://www.stringssg.com/#website"},"breadcrumb":{"@id":"https://www.stringssg.com/sg/personal-trainer/personal-trainer-certification/#breadcrumblist"},"datePublished":"2025-01-06T07:30:46+00:00","dateModified":"${modifiedDate}"}]}`
          }}
        />
        </Head>
        <div>
            <div className='max-w-5xl mx-auto py-5 px-2'>
                <div className='space-y-2 text-center'>
                    <h1 className='text-2xl md:text-3xl font-semibold'>Best Personal Trainer Certifications for Singapore [{year}]</h1>
                    <div className='text-gray-400 text-xs'>
                        <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                    </div>
                </div>
                <div className='py-2  leading-8 space-y-2'>
                    <div className='pt-5'>
                        <p>
                            Personal training certifications are important to be a successful trainer. Here is a list of personal trainer courses that are recognized in Singapore.
                        </p>
                    </div>
                    <div className="relative h-96 w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow">
                        <Image
                        src={s3Static + "fitness-package6.jpg"}
                        fill
                        className="object-cover"
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                        alt="personal trainer certifications in Singapore - StringsSG"
                        />
                    </div>
                    <div className='space-y-2 pb-5'>
                        <h2 className='font-bold pt-5 text-xl'>
                            1. American Council on Exercise (ACE)
                        </h2>
                        <p> 
                            ACE is one of the most popular certification for personal trainers. If you are just getting started on your personal training career this program is
                            highly recommended for you.
                        </p>     
                        <p>
                            The ACE training program with help with the skills to build unique workout programs based on your client&apos;s fitness level, goal and other requirements, 
                            which will make the personal trainers&apos; client centric.
                            An ACE certified personal trainer is equipped with the knowledge of science behind every exercise they incorporate in their training program.
                        </p>           
                        <p>
                            An ACE certified personal trainer is equipped with the knowledge of science behind every exercise they incorporate in their training program.
                        </p>      
                        <p>
                            Website - 
                            <a className='text-orange-600' href="https://www.acefitness.org/fitness-certifications/personal-trainer-certification/default.aspx" target="_blank" rel="noreferrer noopener nofollow"> ACE Certification</a>
                        </p>
                        <p>
                            ACE Certification Cost - Starts from $489
                        </p>
                        <h2 className='font-bold pt-5 text-xl'>
                            2. National Academy of Sports Medicine (NASM)
                        </h2>
                        <p> 
                            NASM is one of the most respected personal trainer certification that one can possess. National Academy of Sports Medicine has developed the most successful 
                            personal trainers in the fitness industry. The NCCA-accredited personal trainer certification provides you with the most scientifically accurate 
                            information, all delivered in our revolutionary digital learning platform. If you want to become one of the best, most respected, and highest-paid 
                            fitness trainers, it&apos;s as simple as getting certified online with NASM.
                        </p>                    
                        <p>
                            Website - 
                            <a className='text-orange-600' href="https://www.nasm.org/become-a-personal-trainer" target="_blank" rel="noreferrer noopener nofollow"> NASM Certification</a>
                        </p>
                        <p>
                            NASM Certification Cost - Starts from $699
                        </p>
                        <h2 className='font-bold pt-5 text-xl'>
                            3. International Sports Sciences Association (ISSA)
                        </h2>
                        <p>
                            ISSA is the highest rated and reviewed personal trainer certification on Trustpilot. International Sports Sciences Association focuses on 
                            how to pinpoint the most effective exercise for your client by detailing the execution of the training program with accurate diet plan.
                            ISSA certification covers extensive knowledge of human muscle and skeletal structure.
                        </p>
                        <p>
                            The passing score of ISSA is higher in comparison to other personal training certification programs, but the retest could be free of cost.
                        </p>
                        <p>
                            Website - 
                            <a className='text-orange-600' href="https://www.issaonline.com/" target="_blank" rel="noreferrer noopener nofollow"> ISSA Certification</a>
                        </p>
                        <p>
                            ISSA Certification Cost - Starts from $69/month
                        </p>
                        <h2 className='font-bold pt-5 text-xl'>
                            4. Federation of International Sports, Aerobics and Fitness (FISAF)
                        </h2>
                        <p>
                            The Federation of International Sports, Aerobics and Fitness claims to be the largest fitness industry organization in the world. It is a non-profit
                            democratic independent organization controlled by its members. FISAF members form a synergistic network of expertise, resources and activities 
                            to support the development of the fitness and aerobics industries in over 40 countries.
                        </p>
                        <p>
                            FISAF provides unique certification programs for Aqua Instructors and Aerobics.
                        </p>
                        <p>
                            Website - 
                            <a className='text-orange-600' href="https://fisaf.com.sg/" target="_blank" rel="noreferrer noopener nofollow"> FISAF Certification</a>
                        </p>
                        <h2 className='font-bold pt-5 text-xl'>
                            5. American College of Sports Medicine (ACSM)
                        </h2>
                        <p>
                            ACMS offer unique certification programs in four different categories: 
                        </p>
                        <ul className='px-4'>
                            <li className='list-disc'>
                                <strong>Group Exercise Instructor</strong> - An ACSM Certified Group Exercise Instructor® (ACSM-GEI) has earned a high school diploma and 
                                works in a group exercise setting with apparently healthy people and those with health challenges who can still exercise independently.
                            </li>
                            <li className='list-disc'>
                                <strong>Personal Trainer</strong> - An ACSM Certified Personal Trainer® (ACSM-CPT) has earned a high school diploma or GED and works with 
                                apparently healthy clients and those with stable health challenges who have been cleared to exercise independently.
                            </li>
                            <li className='list-disc'>
                                <strong>Exercise Physiologist</strong> - An ACSM Certified Exercise Physiologist® (ACSM-EP) has a bachelor&apos;s degree or higher in exercise 
                                science and works with healthy clients and those with medically controlled conditions to establish safe, healthy and effective exercise and lifestyle behaviors.
                            </li>
                            <li className='list-disc'>
                                <strong>Clinical Exercise Physiologist</strong> - An ACSM Certified Clinical Exercise Physiologist® (ACSM-CEP) holds a bachelor&apos;s degree or 
                                equivalent qualification in exercise science with 1,200 hours of hands-on experience or a master&apos;s degree in clinical exercise physiology and 600 hours 
                                of clinical experience. ACSM-CEPs use prescribed exercise and basic health behavior interventions to assist clients with chronic diseases or conditions.
                            </li>
                        </ul>                            
                        <p>
                            Website - 
                            <a className='text-orange-600' href="https://www.acsm.org/certification/get-certified" target="_blank" rel="noreferrer noopener nofollow"> ACSM Certification</a>
                        </p>   
                    </div> 
                </div>
                <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
            </div>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
            {`!function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '128634041116395');
                        fbq('track', 'PageView');`}
            </Script>
    </>
  )
}
